import ChosenReceiptBlock from './ChosenReceiptBlock';

export default ChosenReceiptBlock;
